import { Box, Heading, Container, Text, Button, Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { redirectToExternalLink } from '../../../components/Links';
import { CONSTANTS } from '../../../constants/generalConstants';
import { RemindAppFeatures } from './Features';
import OpenSourceBanner, { WebsiteDeprecationNotice } from '../../../components/banner/OpenSourceBanner';

export default function ReminderAppProduct() {
	useEffect(() => {
		document.title = 'Reminder App - AppsForChat (Now Open Source!)';
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			<OpenSourceBanner />
			<Container maxW={'6xl'}>
				<WebsiteDeprecationNotice />
			</Container>
			<Container maxW={'3xl'}>
				<Stack
					as={Box}
					textAlign={'center'}
					spacing={{ base: 8, md: 14 }}
					py={{ base: 20, md: 36 }}
				>
					<Heading
						fontWeight={600}
						fontSize={{ base: '2xl', sm: '4xl', md: '5xl' }}
						lineHeight={'110%'}
					>
						Create Reminders in <br />
						<Text as={'span'} color={'red.400'}>
							Rocket.Chat
						</Text>
					</Heading>
					<Text
						color={'gray.500'}
						fontSize={{
							base: 'lg',
							md: 'xl',
						}}
					>
						Automate reminders for you and your team, track who
						has completed tasks, and keep your work and personal
						life organized with reminders, right from
						Rocket.Chat.
					</Text>
					<Box
						bg="green.50"
						border="2px solid"
						borderColor="green.400"
						borderRadius="lg"
						p={6}
						my={4}
					>
						<Heading size="md" color="green.600" mb={2}>
							✨ Now 100% Free & Open Source!
						</Heading>
						<Text color="gray.700" fontSize="lg">
							No license required • Unlimited reminders • All features unlocked
						</Text>
					</Box>
					<Stack
						direction={'column'}
						spacing={3}
						align={'center'}
						alignSelf={'center'}
						position={'relative'}
					>
						<Button
							colorScheme={'green'}
							bg={'green.400'}
							rounded={'full'}
							px={6}
							size="lg"
							_hover={{
								bg: 'green.500',
							}}
							onClick={() => {
								redirectToExternalLink(
									CONSTANTS.GITHUB_URL,
								);
							}}
						>
							View on GitHub
						</Button>
						<Button
							colorScheme={'blue'}
							variant="outline"
							rounded={'full'}
							px={6}
							onClick={() => {
								redirectToExternalLink(
									CONSTANTS.REMINDER_APP_DOCS_URL,
								);
							}}
						>
							Read Documentation
						</Button>
					</Stack>
				</Stack>
			</Container>
			<RemindAppFeatures />
		</>
	);
}
